<script lang="ts">
  import type { DataTableCell } from 'carbon-components-svelte/src/DataTable/DataTable.svelte';

  import DataFeedActionsCell from './cells/DataFeedActionsCell.svelte';
  import DataFeedDateCell from './cells/DataFeedDateCell.svelte';
  import DataFeedNameCell from './cells/DataFeedNameCell.svelte';

  import { DATE_CELL_KEYS } from './entitlements-table-constants';
  import type {
    Approval,
    DateCellKey,
    EntitlementMetadata,
    EntitlementRow,
    FeedMetadata,
    RowValidationErrors,
  } from './entitlements-table-types';

  export let cell: DataTableCell,
    row: EntitlementRow,
    feedIdsRequiringApprovalSet: Set<string>,
    savedEntitlementIdsSet: Set<string>,
    feedMetadata: FeedMetadata,
    approval: Approval,
    entitlementMetadata: EntitlementMetadata,
    serviceId: number,
    rowValidationErrors: RowValidationErrors = {};

  const isDateCellKey = (key: string): key is DateCellKey => DATE_CELL_KEYS.includes(key as DateCellKey);
</script>

{#if cell.key === 'name'}
  <DataFeedNameCell
    {cell}
    {row}
    {feedIdsRequiringApprovalSet}
    {savedEntitlementIdsSet}
    {feedMetadata}
    {approval}
    {entitlementMetadata}
    {serviceId}
    on:open-modal
  />
{:else if cell.key === 'actions'}
  <DataFeedActionsCell {row} {rowValidationErrors} on:delete-row on:change-row />
{:else if isDateCellKey(cell.key)}
  <DataFeedDateCell {row} cellKey={cell.key} {rowValidationErrors} on:change-row on:toggle-is-ongoing on:toggle-day-entitlement />
{:else}
  {cell.value}
{/if}
